// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Game$ReactTemplate = require("./Game.bs.js");
var FigurePreviews$ReactTemplate = require("./FigurePreviews.bs.js");

function App(Props) {
  return React.createElement("div", undefined, React.createElement("h1", undefined, "Game of life"), React.createElement("p", undefined, React.createElement("a", {
                      href: "https://en.wikipedia.org/wiki/Conway%27s_Game_of_Life",
                      target: "_blank"
                    }, "What is it? (Wiki)")), React.createElement("h2", undefined, "Figures"), React.createElement(FigurePreviews$ReactTemplate.make, {
                  figures: [
                    /* tuple */[
                      "Glider",
                      [
                        /* tuple */[
                          1,
                          0
                        ],
                        /* tuple */[
                          2,
                          1
                        ],
                        /* tuple */[
                          0,
                          2
                        ],
                        /* tuple */[
                          1,
                          2
                        ],
                        /* tuple */[
                          2,
                          2
                        ]
                      ]
                    ],
                    /* tuple */[
                      "Blinker",
                      [
                        /* tuple */[
                          0,
                          0
                        ],
                        /* tuple */[
                          1,
                          0
                        ],
                        /* tuple */[
                          2,
                          0
                        ]
                      ]
                    ],
                    /* tuple */[
                      "Beacon",
                      [
                        /* tuple */[
                          0,
                          0
                        ],
                        /* tuple */[
                          1,
                          0
                        ],
                        /* tuple */[
                          0,
                          1
                        ],
                        /* tuple */[
                          3,
                          3
                        ],
                        /* tuple */[
                          3,
                          2
                        ],
                        /* tuple */[
                          2,
                          3
                        ]
                      ]
                    ]
                  ]
                }), React.createElement(Game$ReactTemplate.make, { }));
}

var make = App;

exports.make = make;
/* react Not a pure module */
